import { any, none, all, first, firstOrDefault, remove, replace, select, where, orderBy, count, descending, peek } from '.';

Array.prototype.any = Array.prototype.any || function( ...args ) {
  return any( this, ...args ); 
};
Array.prototype.all = Array.prototype.all || function( ...args ) {
  return all( this, ...args ); 
};
Array.prototype.none = Array.prototype.none || function( ...args ) {
  return none( this, ...args ); 
};
Array.prototype.first = Array.prototype.first || function( ...args ) {
  return first( this, ...args ); 
};
Array.prototype.firstOrDefault = Array.prototype.firstOrDefault || function( ...args ) {
  return firstOrDefault( this, ...args ); 
};
Array.prototype.remove = Array.prototype.remove || function( ...args ) {
  return remove( this, ...args ); 
};
Array.prototype.replace = Array.prototype.replace || function( ...args ) {
  return replace( this, ...args ); 
};
Array.prototype.select = Array.prototype.select || function( ...args ) {
  return select( this, ...args ); 
};
Array.prototype.where = Array.prototype.where || function( ...args ) {
  return where( this, ...args ); 
};
Array.prototype.orderBy = Array.prototype.orderBy || function( ...args ) {
  return orderBy( this, ...args ); 
};
Array.prototype.descending = Array.prototype.descending || function( ...args ) {
  return descending( this, ...args ); 
};
Array.prototype.count = Array.prototype.count || function( ...args ) {
  return count( this, ...args ); 
};

Array.prototype.peek = Array.prototype.peek || function () {
  return peek( this );
}

const Generator = Generator || Object.getPrototypeOf( function* () {} );

Generator.prototype.firstOrDefault = Generator.prototype.firstOrDefault || function( predicate ) { 
  let value = this.next();
  if ( predicate ) {
    while ( !value.done && !predicate( value.value ) ) {
      value = this.next();
    }
  }
  return value.value || null;
};

Generator.prototype.any = Generator.prototype.any || function( predicate ) {
  let value = this.next();
  if ( predicate ) {
    while ( !value.done && !predicate( value.value ) ) {
      value = this.next();
    }
  }
  return value.done === false;
};

Generator.prototype.none = Generator.prototype.none || function( ...args ) {
  return !this.any( ...args ); 
};

Generator.prototype.all = Generator.prototype.all || function( predicate ) {
  return this.none( p => !predicate( p ) );
};

Generator.prototype.first = Generator.prototype.first || function( ...args ) { 
  let value = this.firstOrDefault( ...args ); 
  if ( value === null ) {
    throw 'InvalidOperationException: Sequence doesn\'t contain element';
  }
  return value;
};

Generator.prototype.select = Generator.prototype.select || function( transform = t => t ) {
  let result = [];
  let value = this.next();
  while ( !value.done ) {
    result.push( transform( value.value ) );
    value = this.next();
  }
  return result;
};

Generator.prototype.where = Generator.prototype.where || function*( predicate ) {
  let value = this.next();
  while ( !value.done ) {
    if ( predicate( value.value ) ) {
      yield value.value;
    }
    value = this.next();
  }
};

Generator.prototype.orderBy = Generator.prototype.orderBy || function( orderValueSelector = t => t ) {
  return this.select().orderBy( orderValueSelector );
};

Generator.prototype.count = Generator.prototype.count || function( predicate ) {
  if ( !predicate ) {
    return this.select().length;
  }
  return this.where( predicate ).select().length;
};